import React, {useEffect, useState} from 'react';
import { debounce } from 'utils/util';

interface IUseResize {
  defaultValue:any;
  onChange:(e:any)=>any;
}

export default (props:IUseResize)=>{
  const {defaultValue, onChange} = props;
  const [value, setValue] = useState(defaultValue);

  useEffect(()=>{
    const onResize = debounce((e?:any)=>{
      setValue(onChange(e));
    }, 500, false);
    
    onResize();
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    // window.addEventListener('fullscreenchange', onResize);

    return ()=>{
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      // window.removeEventListener('fullscreenchange', onResize);
    }
  }, [value]);

  return [value, setValue];
}
